import IconDragVertical from '~icons/carbon/drag-vertical';
import { su, theme } from '@arc/frontend/ui-theme';
export function DraggableHandle({
  iconStyle,
  Icon = IconDragVertical
}) {
  return <Icon css={[su.text2xl, {
    width: '1em',
    height: '1em',
    alignSelf: 'center',
    minWidth: '1em',
    color: '#a8d9ff',
    '&:active, &:hover, &:focus': {
      color: theme.colors.palettes.primary.main
    }
  }, iconStyle, process.env.NODE_ENV === "production" ? "" : ";label:DraggableHandle;"]} />;
}